import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import "@/styles/globals.css"
import { TooltipProvider } from "@shared/ui/components/tooltip"

import { I18nProvider } from "@/lib/i18n/client"
import { AppProviders } from "@/components/app-providers"
import { SiteHeader } from "@/components/site-header"
import { MobileBottomCta } from "@/components/mobile-bottom-cta"
import { SiteFooter } from "@/components/site-footer"
import { HeroSection } from "@/features/sections/hero-section"
import { LiveScanSection } from "@/features/sections/live-scan-section"
import { RiskAnalysisSection } from "@/features/sections/risk-analysis-section"
import { WorldPulseSection } from "@/features/sections/world-pulse-section"
import { EnterpriseSection } from "@/features/sections/enterprise-section"
import { ReportShowcaseSection } from "@/features/sections/report-showcase-section"
import { TestimonialsSection } from "@/features/sections/testimonials-section"

const root = document.getElementById("root")

if (!root) {
  throw new Error("Root element #root not found")
}

function App() {
  return (
    <>
      <SiteHeader />
      <main>
        <HeroSection />
        <LiveScanSection />
        <RiskAnalysisSection />
        <WorldPulseSection />
        <EnterpriseSection />
        <ReportShowcaseSection />
        <TestimonialsSection />
        <SiteFooter />
      </main>
      <MobileBottomCta />
    </>
  )
}

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <AppProviders>
        <TooltipProvider>
          <App />
        </TooltipProvider>
      </AppProviders>
    </I18nProvider>
  </StrictMode>,
)
